var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      staticClass: "product-container",
      attrs: { "data-testing": _vm.item.variation.id }
    },
    [
      _c("add-to-wish-list", {
        staticClass: "d-none",
        attrs: { short: true, "variation-id": _vm.item.variation.id }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "product-pictures" },
        [
          _c("item-store-special", {
            attrs: {
              "recommended-retail-price": _vm.item.prices.rrp,
              "variation-retail-price": _vm.item.prices.default,
              "decimal-count": _vm.decimalCount,
              availability: _vm.item.variation.availabilityId,
              "current-shop-sale": _vm.showCurrentSaleTag
            }
          }),
          _vm._v(" "),
          _vm._t("add-to-basket", [
            _c("add-to-basket", {
              attrs: {
                "data-testing": "item-add-to-basket",
                "variation-id": _vm.item.variation.id,
                "is-salable": !!_vm.item.filter && _vm.item.filter.isSalable,
                "has-children":
                  !!_vm.item.item && _vm.item.item.salableVariationCount > 1,
                "interval-quantity":
                  _vm.item.variation.intervalOrderQuantity || 1,
                "minimum-quantity": _vm.item.variation.minimumOrderQuantity,
                "maximum-quantity":
                  !!_vm.item.variation.maximumOrderQuantity &&
                  _vm.item.variation.maximumOrderQuantity > 0
                    ? _vm.item.variation.maximumOrderQuantity
                    : null,
                "order-properties": _vm.item.properties.filter(function(prop) {
                  return prop.property.isOderProperty
                }),
                "has-order-properties": _vm.item.hasOrderProperties,
                "has-required-order-property":
                  _vm.item.hasRequiredOrderProperty,
                "use-large-scale": false,
                "button-size": "sm",
                "show-quantity": false,
                "item-url": _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
                "has-price": _vm._f("hasItemDefaultPrice")(_vm.item),
                "has-graduated-price":
                  _vm.itemGraduatedPriceisCheapestSorting ||
                  _vm.itemGraduatedPricesalableVariationCount,
                "item-type": _vm.item.item.itemType
              }
            })
          ]),
          _vm._v(" "),
          _vm._t("item-image", [
            _c("category-image-carousel", {
              ref: "categoryImageCarousel",
              attrs: {
                "image-urls-data": _vm._f("itemImages")(
                  _vm.item.images,
                  _vm.imageUrlAccessor
                ),
                alt: _vm._f("itemName")(_vm.item),
                title: _vm._f("itemName")(_vm.item),
                "item-url": _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId),
                "enable-carousel": _vm.$ceres.config.item.enableImageCarousel,
                "disable-carousel-on-mobile": _vm.disableCarouselOnMobile
              }
            })
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm._t("product-details", [
        _c("div", { staticClass: "product-meta" }, [
          _c("span", {
            staticClass: "brand",
            domProps: { innerHTML: _vm._s(_vm.brandName) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "prices" }, [
            _vm.item.prices.rrp &&
            _vm.item.prices.rrp.price.value > 0 &&
            _vm.item.prices.rrp.price.value >
              _vm.item.prices.default.price.value
              ? _c("div", { staticClass: "crossPrice" }, [
                  _vm.item.prices.specialOffer
                    ? _c("del", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.item.prices.default.unitPrice.formatted
                            ) +
                            "\n                        "
                        )
                      ])
                    : _c("del", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.item.prices.rrp.unitPrice.formatted) +
                            "\n                        "
                        )
                      ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "price",
              domProps: { innerHTML: _vm._s(_vm.itemPrice) }
            }),
            _vm._v(" "),
            !(
              _vm.item.unit.unitOfMeasurement === "C62" &&
              _vm.item.unit.content === 1
            )
              ? _c("div", { staticClass: "category-unit-price small" }, [
                  _c("span", [_vm._v(_vm._s(_vm.item.unit.content))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(" " + _vm._s(_vm.item.unit.names.name))]),
                  _vm._v(" "),
                  _vm.item.variation.mayShowUnitPrice
                    ? _c("span", [_vm._v(" | " + _vm._s(_vm.basePrice))])
                    : _vm._e()
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("a", {
          staticClass: "product-name",
          attrs: { href: _vm._f("itemURL")(_vm.item, _vm.urlWithVariationId) },
          domProps: { innerHTML: _vm._s(_vm.itemName) }
        }),
        _vm._v(" "),
        _vm.hasVariations
          ? _c("span", { staticClass: "variationHint" }, [
              _vm._v("in mehreren Varianten")
            ])
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }